"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledGridTotalCellWrapper = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const typo_1 = require("../../../../../design/constants/typo");
const base_1 = require("../../../../../design/themes/base");
exports.StyledGridTotalCellWrapper = styled_components_1.default.div `
    display: flex;
    flex-direction: row;
    background-color: ${base_1.baseTheme.colorHighlightNotification.var()};
    align-items: center;
    align-self: stretch;
    flex-grow: 1;

    ${({ isHighlighted }) => isHighlighted
    ? (0, styled_components_1.css) `
                  --grid-cell-text-font: ${typo_1.typo.typoFontMainBold.var()};
              `
    : (0, styled_components_1.css) `
                  & > * {
                      background-color: transparent;
                  }
              `}
`;
//# sourceMappingURL=GridTotalCellWrapper.styles.js.map